import {CourseTests} from '../core/interface/questions.interface';
export const dinamicQuestionModules:CourseTests[]=[
  {
    courseId:1,
    modules:[
      {
        moduleType:'intermediate',
        moduleNumber:'1',
        moduleTitle:'Боевой стресс и посттравматическое стрессовое расстройство',
        questions:[
          {
            title: 'Какие изменения в эмоциональной сфере могут происходить после получения боевого опыта?',
            correct: '3',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: '1',
                label: 'Только повышение настроения и постоянная эйфория.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: '2',
                label: 'Полное исчезновение любых эмоций.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: '3',
                label: 'Колебания настроения, снижение способности испытывать радость, приступы подавленности, чувство вины.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: '4',
                label: 'Исключительно агрессия и злость на всех окружающих.'
              }
            ]
          },
          {
            title: 'После боевого опыта мир может казаться враждебным, а сам человек – никчёмным. Что важно понять, чтобы начать возвращаться к нормальной жизни?',
            correct: '2',
            options: [
              {
                id: 'question2-a',
                controlName: 'question2',
                required:true,
                value: '1',
                label: 'Нужно смириться, что мир действительно не так хорош, и жить в этом убеждении.'
              },
              {
                id: 'question2-b',
                controlName: 'question2',
                required:true,
                value: '2',
                label: 'Нужно понять, что произошло разрушение прежних представлений о мире и о себе и эти представления можно восстановить с течением времени и с помощью психолога.'
              },
              {
                id: 'question2-c',
                controlName: 'question2',
                required:true,
                value: '3',
                label: 'Нужно убедить себя, что ничего не изменилось, и жить как раньше.'
              },
              {
                id: 'question2-d',
                controlName: 'question2',
                required:true,
                value: '4',
                label: 'Нужно доказать себе и миру, что ты сильный, снова пойдя на риск.'
              }
            ]
          },
          {
            title: 'После пережитого иногда возникает желание полностью убрать из жизни всё, что может напомнить о прошлом, будь то форма, поездки на машине или даже определённые мысли и разговоры. К чему приводит такое избегание?',
            correct: '2',
            options: [
              {
                id: 'question3-a',
                controlName: 'question3',
                required:true,
                value: '1',
                label: 'К быстрому и гарантированному выздоровлению.'
              },
              {
                id: 'question3-b',
                controlName: 'question3',
                required:true,
                value: '2',
                label: 'К тому, что человек остаётся один на один со своей проблемой, отгораживаясь от помощи и возможности её обсудить.'
              },
              {
                id: 'question3-c',
                controlName: 'question3',
                required:true,
                value: '3',
                label: 'К тому, что воспоминания полностью стираются из памяти навсегда.'
              },
              {
                id: 'question3-d',
                controlName: 'question3',
                required:true,
                value: '4',
                label: 'К развитию сверхспособностей и обострению всех чувств.'
              }
            ]
          },
        ]
      },
      {
        moduleType:'intermediate',
        moduleTitle:'Способы преодоления жизненных кризисов',
        moduleNumber:'2',
        questions:[
          {
            title: 'Что чаще всего мешает вернуться к мирной жизни и вызывает главный внутренний конфликт?',
            correct: '4',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: '1',
                label: 'Физическая усталость и нехватка сил для домашних дел.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: '2',
                label: 'Нежелание семьи и общества предоставить ветерану полную свободу действий.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: '3',
                label: 'Отсутствие денег и материальных благ, к которым человек привык на фронте.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: '4',
                label: 'Кризис идентичности, когда человек не может соединить воедино себя «до», «во время» и «после» участия в боевых действиях.'
              }
            ]
          },
          {
            title: 'Кризис – это не всегда только плохо. Какой ещё взгляд на кризис предлагается?',
            correct: '3',
            options: [
              {
                id: 'question2-a',
                controlName: 'question2',
                required:true,
                value: '1',
                label: 'Кризис – это всегда наказание за прошлые ошибки.'
              },
              {
                id: 'question2-b',
                controlName: 'question2',
                required:true,
                value: '2',
                label: 'Кризис – это просто временное помешательство, которое нужно перетерпеть.'
              },
              {
                id: 'question2-c',
                controlName: 'question2',
                required:true,
                value: '3',
                label: 'Кризис – это событие, которое может открывать новые горизонты и возможности, если подойти к нему как к шансу.'
              },
              {
                id: 'question2-d',
                controlName: 'question2',
                required:true,
                value: '4',
                label: 'Кризис – это состояние, в котором лучше всего ничего не менять и плыть по течению.'
              }
            ]
          },
          {
            title: 'Критическая стадия кризиса характеризуется очень тяжёлым состоянием. Что является главным признаком того, что человек оказался именно на этой стадии?',
            correct: '2',
            options: [
              {
                id: 'question3-a',
                controlName: 'question3',
                required:true,
                value: '1',
                label: 'Беспокойство и желание обратиться за советом к друзьям.'
              },
              {
                id: 'question3-b',
                controlName: 'question3',
                required:true,
                value: '2',
                label: 'Чувство беспомощности и безнадёжности, полная дезорганизация поведения, разрушение адаптационных механизмов и непонимание, куда обращаться за помощью.'
              },
              {
                id: 'question3-c',
                controlName: 'question3',
                required:true,
                value: '3',
                label: 'Активный поиск новых решений и мобилизация всех внутренних ресурсов.'
              },
              {
                id: 'question3-d',
                controlName: 'question3',
                required:true,
                value: '4',
                label: 'Использование старых, привычных способов решения, которые уже однажды помогали.'
              }
            ]
          },
          {
            title: 'Какое из перечисленных состояний является ключевым признаком внутреннего ощущения одиночества?',
            correct: '1',
            options: [
              {
                id: 'question4-a',
                controlName: 'question4',
                required:true,
                value: '1',
                label: 'Чувство потерянности в мире, ощущение себя ненужным и отсутствие точки опоры в виде доверительных отношений.'
              },
              {
                id: 'question4-b',
                controlName: 'question4',
                required:true,
                value: '2',
                label: 'Наличие большого количества знакомых и приятелей.'
              },
              {
                id: 'question4-c',
                controlName: 'question4',
                required:true,
                value: '3',
                label: 'Желание побыть одному, чтобы подумать о чём-то важном.'
              },
              {
                id: 'question4-d',
                controlName: 'question4',
                required:true,
                value: '4',
                label: 'Отсутствие свободного времени из-за постоянного общения с людьми.'
              }
            ]
          },
        ]
      },
      {
        moduleType:'intermediate',
        moduleNumber:'3',
        moduleTitle:'Семейные отношения как ресурс для преодоления психологических трудностей',
        questions:[
          {
            title: 'Человеку, пережившему боевой стресс и нуждающемуся в помощи, важно вести себя активно. Что это означает?',
            correct: '3',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: '1',
                label: 'Нужно начать заниматься спортом и вести активный образ жизни.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: '2',
                label: 'Активность означает, что нужно постоянно давать советы другим, а не просить помощи для себя.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: '3',
                label: 'Важно не только говорить о своих потребностях, но и самому предпринимать шаги для их удовлетворения и получения поддержки.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: '4',
                label: 'Нужно как можно реже появляться дома, чтобы не нагружать семью своими проблемами.'
              }
            ]
          },
          {
            title: 'Почему после возвращения с фронта привычная гражданская жизнь может казаться чуждой и вызывать трудности адаптации?',
            correct: '2',
            options: [
              {
                id: 'question2-a',
                controlName: 'question2',
                required:true,
                value: '1',
                label: 'Потому что за время отсутствия все знакомые люди специально изменили своё отношение.'
              },
              {
                id: 'question2-b',
                controlName: 'question2',
                required:true,
                value: '2',
                label: 'Потому что внешне всё выглядит по-старому, но сам человек изменился и ему заново нужно искать смыслы и адаптироваться к «старым – новым» условиям.'
              },
              {
                id: 'question2-c',
                controlName: 'question2',
                required:true,
                value: '3',
                label: 'Потому что в гражданской жизни вообще нет никаких правил и порядка.'
              },
              {
                id: 'question2-d',
                controlName: 'question2',
                required:true,
                value: '4',
                label: 'Потому что семья перестала заботиться о вернувшемся военнослужащем.'
              }
            ]
          },
          {
            title: 'Ветеран говорит: «Жена и дети ждали меня, но я чувствую, что мы стали чужими. Они живут своей жизнью, а я – своей. Я не знаю, как снова стать для них близким». Какие действия будут наиболее эффективными для восстановления близости?',
            correct: '1',
            options: [
              {
                id: 'question3-a',
                controlName: 'question3',
                required:true,
                value: '1',
                label: 'Начать с малого: каждый день находить время для простого разговора с женой, интересоваться делами детей и делиться своими мыслями, даже если это кажется неловким.'
              },
              {
                id: 'question3-b',
                controlName: 'question3',
                required:true,
                value: '2',
                label: 'Дать семье время привыкнуть и не навязываться, подождать, пока они сами проявят инициативу.'
              },
              {
                id: 'question3-c',
                controlName: 'question3',
                required:true,
                value: '3',
                label: 'Собрать семейный совет и объяснить, что теперь всё в семье должно быть по-другому.'
              },
              {
                id: 'question3-d',
                controlName: 'question3',
                required:true,
                value: '4',
                label: 'Сосредоточиться на работе и обеспечении семьи, полагая, что финансовый вклад автоматически восстановит отношения.'
              }
            ]
          },
        ]
      },
      {
        moduleType:'intermediate',
        moduleNumber:'4',
        moduleTitle:'Эффективные методы развития мотивации к самореализации',
        questions:[
          {
            title: 'Ветеран вернулся домой и понимает: нужно пройти медобследование, достроить баню, навестить старых друзей, разобрать накопившиеся счета. С чего ему начать планирование своих дел?',
            correct: '4',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: '1',
                label: 'Начать с самого простого и быстрого дела, чтобы почувствовать удовлетворение от выполненного.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: '2',
                label: 'Составить список из 10 дел на ближайшие 10 лет и строго ему следовать, не отвлекаясь на мелочи.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: '3',
                label: 'Сделать всё и сразу, потому что после боевых действий для него нет невыполнимых задач.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: '4',
                label: 'Разделить все дела на неважные и срочные, выполнить сначала то, что не терпит отлагательств (например, здоровье), а остальное распределить по времени или делегировать.'
              }
            ]
          },
          {
            title: 'Какой инструмент можно использовать для анализа мотивации и принятия решения о необходимости что-то менять в жизни?',
            correct: '4',
            options: [
              {
                id: 'question2-a',
                controlName: 'question2',
                required:true,
                value: '1',
                label: 'Матрица Эйзенхауэра.'
              },
              {
                id: 'question2-b',
                controlName: 'question2',
                required:true,
                value: '2',
                label: 'Правило 10/10/10.'
              },
              {
                id: 'question2-c',
                controlName: 'question2',
                required:true,
                value: '3',
                label: 'Пирамида потребностей.'
              },
              {
                id: 'question2-d',
                controlName: 'question2',
                required:true,
                value: '4',
                label: 'Квадрат Декарта, чтобы взвесить плюсы и минусы сохранения текущего положения дел и изменений.'
              }
            ]
          },
          {
            title: 'Почему обращение за психологической или медицинской помощью может быть необходимо тем, кто вернулся с фронта?',
            correct: '3',
            options: [
              {
                id: 'question3-a',
                controlName: 'question3',
                required:true,
                value: '1',
                label: 'Потому что все ветераны автоматически имеют психические недуги.'
              },
              {
                id: 'question3-b',
                controlName: 'question3',
                required:true,
                value: '2',
                label: 'Потому что врачам нужно отчитываться о количестве пациентов.'
              },
              {
                id: 'question3-c',
                controlName: 'question3',
                required:true,
                value: '3',
                label: 'Потому что пережитый тяжёлый стресс может вызывать проблемы со сном, тревогу, признаки депрессии или ПТСР, которые мешают нормальной жизни, а специалист поможет с ними справиться.'
              },
              {
                id: 'question3-d',
                controlName: 'question3',
                required:true,
                value: '4',
                label: 'Потому что так принято в обществе'
              }
            ]
          },
        ]
      },
      {
        moduleType:'intermediate',
        moduleNumber:'5',
        moduleTitle:'Мотивация и траектория: построение новой карьеры ветерана СВО',
        questions:[
          {
            title: 'Ветеран говорит: «Раньше я жил как будто на черновик, а теперь хочу по-настоящему. Но не знаю, с чего начать. Всё, что делал раньше на гражданке, кажется теперь пустым». Как начать проектирование новой жизни?',
            correct: '2',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: '1',
                label: 'Возврат на прежнюю высокооплачиваемую работу ради стабильности.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: '2',
                label: 'Погружение в детские воспоминания и поиск занятий, приносящих радость.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: '3',
                label: 'Запись на курсы по самой востребованной профессии в городе.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: '4',
                label: 'Полугодовой отпуск и пассивное ожидание новых желаний.'
              }
            ]
          },
          {
            title: 'Как ограничение по здоровью (например, потеря слуха) может стать суперсилой и преимуществом при выборе профессии?',
            correct: '1',
            options: [
              {
                id: 'question2-a',
                controlName: 'question2',
                required:true,
                value: '1',
                label: 'Потеря слуха становится суперсилой для работы в условиях, где шум является проблемой для других (шумный цех, работа в такси), позволяя лучше фокусироваться.'
              },
              {
                id: 'question2-b',
                controlName: 'question2',
                required:true,
                value: '2',
                label: 'Это ограничение не может стать преимуществом – это всегда только минус.'
              },
              {
                id: 'question2-c',
                controlName: 'question2',
                required:true,
                value: '3',
                label: 'С таким ограничением можно работать только на дому и никуда не выходить.'
              },
              {
                id: 'question2-d',
                controlName: 'question2',
                required:true,
                value: '4',
                label: 'Это повод оформить инвалидность и больше не работать.'
              }
            ]
          },
          {
            title: 'Как поступить, если работа мечты низкооплачиваемая, а высокооплачиваемая кажется скучной?',
            correct: '1',
            options: [
              {
                id: 'question3-a',
                controlName: 'question3',
                required:true,
                value: '1',
                label: 'Совмещать два вида занятости, удовлетворяя разные интересы и потребности (мультизанятость).'
              },
              {
                id: 'question3-b',
                controlName: 'question3',
                required:true,
                value: '2',
                label: 'Выбрать что-то одно, чтобы не распыляться.'
              },
              {
                id: 'question3-c',
                controlName: 'question3',
                required:true,
                value: '3',
                label: 'Отказаться от идеальной работы и согласиться только на высокооплачиваемую.'
              },
              {
                id: 'question3-d',
                controlName: 'question3',
                required:true,
                value: '4',
                label: 'Ждать, пока появится работа, которая устроит по всем параметрам.'
              }
            ]
          },
        ]
      },
      {
        moduleType:'intermediate',
        moduleNumber:'6',
        moduleTitle:'Упражнения совладания со стрессом',
        questions:[
          {
            title: 'С чего рекомендуется начать работу по созданию личного «антистрессового» арсенала?',
            correct: '2',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: '1',
                label: 'Сразу выучить сложные дыхательные техники.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: '2',
                label: 'Составить максимальный список того, что доставляет удовольствие и радость, и постоянно его дополнять.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: '3',
                label: 'Купить абонемент в спортзал.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: '4',
                label: 'Записаться на приём к психологу.'
              }
            ]
          },
        ]
      },
      {
        moduleType:'intermediate',
        moduleNumber:'7',
        moduleTitle:'Анонс программы наставничества «Равный - равному» ',
        questions:[
          {
            title: 'Для кого предназначена программа наставничества?',
            correct: '3',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: '1',
                label: 'Для всех ветеранов СВО без исключения, главное - желание.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: '2',
                label: 'Для ветеранов с высшим психологическим образованием.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: '3',
                label: 'Для ветеранов, которые преодолели свои кризисы и готовы помогать другим бойцам на пути возвращения к мирной жизни.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: '4',
                label: 'Для родственников ветеранов, которые хотят помочь своим близким.'
              }
            ]
          },
        ]
      },
      {
        moduleType:'final',
        moduleNumber:'1',
        correctAnswersCount:13,
        questions:[
          {
            title: 'Какие изменения в эмоциональной сфере могут происходить после получения боевого опыта?',
            correct: '3',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: '1',
                label: 'Только повышение настроения и постоянная эйфория.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: '2',
                label: 'Полное исчезновение любых эмоций.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: '3',
                label: 'Колебания настроения, снижение способности испытывать радость, приступы подавленности, чувство вины.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: '4',
                label: 'Исключительно агрессия и злость на всех окружающих.'
              }
            ]
          },
          {
            title: 'После боевого опыта мир может казаться враждебным, а сам человек – никчёмным. Что важно понять, чтобы начать возвращаться к нормальной жизни?',
            correct: '2',
            options: [
              {
                id: 'question2-a',
                controlName: 'question2',
                required:true,
                value: '1',
                label: 'Нужно смириться, что мир действительно не так хорош, и жить в этом убеждении.'
              },
              {
                id: 'question2-b',
                controlName: 'question2',
                required:true,
                value: '2',
                label: 'Нужно понять, что произошло разрушение прежних представлений о мире и о себе и эти представления можно восстановить с течением времени и с помощью психолога.'
              },
              {
                id: 'question2-c',
                controlName: 'question2',
                required:true,
                value: '3',
                label: 'Нужно убедить себя, что ничего не изменилось, и жить как раньше.'
              },
              {
                id: 'question2-d',
                controlName: 'question2',
                required:true,
                value: '4',
                label: 'Нужно доказать себе и миру, что ты сильный, снова пойдя на риск.'
              }
            ]
          },
          {
            title: 'После пережитого иногда возникает желание полностью убрать из жизни всё, что может напомнить о прошлом, будь то форма, поездки на машине или даже определённые мысли и разговоры. К чему приводит такое избегание?',
            correct: '2',
            options: [
              {
                id: 'question3-a',
                controlName: 'question3',
                required:true,
                value: '1',
                label: 'К быстрому и гарантированному выздоровлению.'
              },
              {
                id: 'question3-b',
                controlName: 'question3',
                required:true,
                value: '2',
                label: 'К тому, что человек остаётся один на один со своей проблемой, отгораживаясь от помощи и возможности её обсудить.'
              },
              {
                id: 'question3-c',
                controlName: 'question3',
                required:true,
                value: '3',
                label: 'К тому, что воспоминания полностью стираются из памяти навсегда.'
              },
              {
                id: 'question3-d',
                controlName: 'question3',
                required:true,
                value: '4',
                label: 'К развитию сверхспособностей и обострению всех чувств.'
              }
            ]
          },
          {
            title: 'Что чаще всего мешает вернуться к мирной жизни и вызывает главный внутренний конфликт?',
            correct: '4',
            options: [
              {
                id: 'question4-a',
                controlName: 'question4',
                required:true,
                value: '1',
                label: 'Физическая усталость и нехватка сил для домашних дел.'
              },
              {
                id: 'question4-b',
                controlName: 'question4',
                required:true,
                value: '2',
                label: 'Нежелание семьи и общества предоставить ветерану полную свободу действий.'
              },
              {
                id: 'question4-c',
                controlName: 'question4',
                required:true,
                value: '3',
                label: 'Отсутствие денег и материальных благ, к которым человек привык на фронте.'
              },
              {
                id: 'question4-d',
                controlName: 'question4',
                required:true,
                value: '4',
                label: 'Кризис идентичности, когда человек не может соединить воедино себя «до», «во время» и «после» участия в боевых действиях.'
              }
            ]
          },
          {
            title: 'Кризис – это не всегда только плохо. Какой ещё взгляд на кризис предлагается?',
            correct: '3',
            options: [
              {
                id: 'question5-a',
                controlName: 'question5',
                required:true,
                value: '1',
                label: 'Кризис – это всегда наказание за прошлые ошибки.'
              },
              {
                id: 'question5-b',
                controlName: 'question5',
                required:true,
                value: '2',
                label: 'Кризис – это просто временное помешательство, которое нужно перетерпеть.'
              },
              {
                id: 'question5-c',
                controlName: 'question5',
                required:true,
                value: '3',
                label: 'Кризис – это событие, которое может открывать новые горизонты и возможности, если подойти к нему как к шансу.'
              },
              {
                id: 'question5-d',
                controlName: 'question5',
                required:true,
                value: '4',
                label: 'Кризис – это состояние, в котором лучше всего ничего не менять и плыть по течению.'
              }
            ]
          },
          {
            title: 'Критическая стадия кризиса характеризуется очень тяжёлым состоянием. Что является главным признаком того, что человек оказался именно на этой стадии?',
            correct: '2',
            options: [
              {
                id: 'question6-a',
                controlName: 'question6',
                required:true,
                value: '1',
                label: 'Беспокойство и желание обратиться за советом к друзьям.'
              },
              {
                id: 'question6-b',
                controlName: 'question6',
                required:true,
                value: '2',
                label: 'Чувство беспомощности и безнадёжности, полная дезорганизация поведения, разрушение адаптационных механизмов и непонимание, куда обращаться за помощью.'
              },
              {
                id: 'question6-c',
                controlName: 'question6',
                required:true,
                value: '3',
                label: 'Активный поиск новых решений и мобилизация всех внутренних ресурсов.'
              },
              {
                id: 'question6-d',
                controlName: 'question6',
                required:true,
                value: '4',
                label: 'Использование старых, привычных способов решения, которые уже однажды помогали.'
              }
            ]
          },
          {
            title: 'Какое из перечисленных состояний является ключевым признаком внутреннего ощущения одиночества?',
            correct: '1',
            options: [
              {
                id: 'question7-a',
                controlName: 'question7',
                required:true,
                value: '1',
                label: 'Чувство потерянности в мире, ощущение себя ненужным и отсутствие точки опоры в виде доверительных отношений.'
              },
              {
                id: 'question7-b',
                controlName: 'question7',
                required:true,
                value: '2',
                label: 'Наличие большого количества знакомых и приятелей.'
              },
              {
                id: 'question7-c',
                controlName: 'question7',
                required:true,
                value: '3',
                label: 'Желание побыть одному, чтобы подумать о чём-то важном.'
              },
              {
                id: 'question7-d',
                controlName: 'question7',
                required:true,
                value: '4',
                label: 'Отсутствие свободного времени из-за постоянного общения с людьми.'
              }
            ]
          },
          {
            title: 'Человеку, пережившему боевой стресс и нуждающемуся в помощи, важно вести себя активно. Что это означает?',
            correct: '3',
            options: [
              {
                id: 'question8-a',
                controlName: 'question8',
                required:true,
                value: '1',
                label: 'Нужно начать заниматься спортом и вести активный образ жизни.'
              },
              {
                id: 'question8-b',
                controlName: 'question8',
                required:true,
                value: '2',
                label: 'Активность означает, что нужно постоянно давать советы другим, а не просить помощи для себя.'
              },
              {
                id: 'question8-c',
                controlName: 'question8',
                required:true,
                value: '3',
                label: 'Важно не только говорить о своих потребностях, но и самому предпринимать шаги для их удовлетворения и получения поддержки.'
              },
              {
                id: 'question8-d',
                controlName: 'question8',
                required:true,
                value: '4',
                label: 'Нужно как можно реже появляться дома, чтобы не нагружать семью своими проблемами.'
              }
            ]
          },
          {
            title: 'Почему после возвращения с фронта привычная гражданская жизнь может казаться чуждой и вызывать трудности адаптации?',
            correct: '2',
            options: [
              {
                id: 'question9-a',
                controlName: 'question9',
                required:true,
                value: '1',
                label: 'Потому что за время отсутствия все знакомые люди специально изменили своё отношение.'
              },
              {
                id: 'question9-b',
                controlName: 'question9',
                required:true,
                value: '2',
                label: 'Потому что внешне всё выглядит по-старому, но сам человек изменился и ему заново нужно искать смыслы и адаптироваться к «старым – новым» условиям.'
              },
              {
                id: 'question9-c',
                controlName: 'question9',
                required:true,
                value: '3',
                label: 'Потому что в гражданской жизни вообще нет никаких правил и порядка.'
              },
              {
                id: 'question9-d',
                controlName: 'question9',
                required:true,
                value: '4',
                label: 'Потому что семья перестала заботиться о вернувшемся военнослужащем.'
              }
            ]
          },
          {
            title: 'Ветеран говорит: «Жена и дети ждали меня, но я чувствую, что мы стали чужими. Они живут своей жизнью, а я – своей. Я не знаю, как снова стать для них близким». Какие действия будут наиболее эффективными для восстановления близости?',
            correct: '1',
            options: [
              {
                id: 'question10-a',
                controlName: 'question10',
                required:true,
                value: '1',
                label: 'Начать с малого: каждый день находить время для простого разговора с женой, интересоваться делами детей и делиться своими мыслями, даже если это кажется неловким.'
              },
              {
                id: 'question10-b',
                controlName: 'question10',
                required:true,
                value: '2',
                label: 'Дать семье время привыкнуть и не навязываться, подождать, пока они сами проявят инициативу.'
              },
              {
                id: 'question10-c',
                controlName: 'question10',
                required:true,
                value: '3',
                label: 'Собрать семейный совет и объяснить, что теперь всё в семье должно быть по-другому.'
              },
              {
                id: 'question10-d',
                controlName: 'question10',
                required:true,
                value: '4',
                label: 'Сосредоточиться на работе и обеспечении семьи, полагая, что финансовый вклад автоматически восстановит отношения.'
              }
            ]
          },
          {
            title: 'Ветеран вернулся домой и понимает: нужно пройти медобследование, достроить баню, навестить старых друзей, разобрать накопившиеся счета. С чего ему начать планирование своих дел?',
            correct: '4',
            options: [
              {
                id: 'question11-a',
                controlName: 'question11',
                required:true,
                value: '1',
                label: 'Начать с самого простого и быстрого дела, чтобы почувствовать удовлетворение от выполненного.'
              },
              {
                id: 'question11-b',
                controlName: 'question11',
                required:true,
                value: '2',
                label: 'Составить список из 10 дел на ближайшие 10 лет и строго ему следовать, не отвлекаясь на мелочи.'
              },
              {
                id: 'question11-c',
                controlName: 'question11',
                required:true,
                value: '3',
                label: 'Сделать всё и сразу, потому что после боевых действий для него нет невыполнимых задач.'
              },
              {
                id: 'question11-d',
                controlName: 'question11',
                required:true,
                value: '4',
                label: 'Разделить все дела на неважные и срочные, выполнить сначала то, что не терпит отлагательств (например, здоровье), а остальное распределить по времени или делегировать.'
              }
            ]
          },
          {
            title: 'Какой инструмент можно использовать для анализа мотивации и принятия решения о необходимости что-то менять в жизни?',
            correct: '4',
            options: [
              {
                id: 'question12-a',
                controlName: 'question12',
                required:true,
                value: '1',
                label: 'Матрица Эйзенхауэра.'
              },
              {
                id: 'question12-b',
                controlName: 'question12',
                required:true,
                value: '2',
                label: 'Правило 10/10/10.'
              },
              {
                id: 'question12-c',
                controlName: 'question12',
                required:true,
                value: '3',
                label: 'Пирамида потребностей.'
              },
              {
                id: 'question12-d',
                controlName: 'question12',
                required:true,
                value: '4',
                label: 'Квадрат Декарта, чтобы взвесить плюсы и минусы сохранения текущего положения дел и изменений.'
              }
            ]
          },
          {
            title: 'Почему обращение за психологической или медицинской помощью может быть необходимо тем, кто вернулся с фронта?',
            correct: '3',
            options: [
              {
                id: 'question13-a',
                controlName: 'question13',
                required:true,
                value: '1',
                label: 'Потому что все ветераны автоматически имеют психические недуги.'
              },
              {
                id: 'question13-b',
                controlName: 'question13',
                required:true,
                value: '2',
                label: 'Потому что врачам нужно отчитываться о количестве пациентов.'
              },
              {
                id: 'question13-c',
                controlName: 'question13',
                required:true,
                value: '3',
                label: 'Потому что пережитый тяжёлый стресс может вызывать проблемы со сном, тревогу, признаки депрессии или ПТСР, которые мешают нормальной жизни, а специалист поможет с ними справиться.'
              },
              {
                id: 'question13-d',
                controlName: 'question13',
                required:true,
                value: '4',
                label: 'Потому что так принято в обществе'
              }
            ]
          },
          {
            title: 'Ветеран говорит: «Раньше я жил как будто на черновик, а теперь хочу по-настоящему. Но не знаю, с чего начать. Всё, что делал раньше на гражданке, кажется теперь пустым». Как начать проектирование новой жизни?',
            correct: '2',
            options: [
              {
                id: 'question14-a',
                controlName: 'question14',
                required:true,
                value: '1',
                label: 'Возврат на прежнюю высокооплачиваемую работу ради стабильности.'
              },
              {
                id: 'question14-b',
                controlName: 'question14',
                required:true,
                value: '2',
                label: 'Погружение в детские воспоминания и поиск занятий, приносящих радость.'
              },
              {
                id: 'question14-c',
                controlName: 'question14',
                required:true,
                value: '3',
                label: 'Запись на курсы по самой востребованной профессии в городе.'
              },
              {
                id: 'question14-d',
                controlName: 'question14',
                required:true,
                value: '4',
                label: 'Полугодовой отпуск и пассивное ожидание новых желаний.'
              }
            ]
          },
          {
            title: 'Как ограничение по здоровью (например, потеря слуха) может стать суперсилой и преимуществом при выборе профессии?',
            correct: '1',
            options: [
              {
                id: 'question15-a',
                controlName: 'question15',
                required:true,
                value: '1',
                label: 'Потеря слуха становится суперсилой для работы в условиях, где шум является проблемой для других (шумный цех, работа в такси), позволяя лучше фокусироваться.'
              },
              {
                id: 'question15-b',
                controlName: 'question15',
                required:true,
                value: '2',
                label: 'Это ограничение не может стать преимуществом – это всегда только минус.'
              },
              {
                id: 'question15-c',
                controlName: 'question15',
                required:true,
                value: '3',
                label: 'С таким ограничением можно работать только на дому и никуда не выходить.'
              },
              {
                id: 'question15-d',
                controlName: 'question15',
                required:true,
                value: '4',
                label: 'Это повод оформить инвалидность и больше не работать.'
              }
            ]
          },
          {
            title: 'Как поступить, если работа мечты низкооплачиваемая, а высокооплачиваемая кажется скучной?',
            correct: '1',
            options: [
              {
                id: 'question16-a',
                controlName: 'question16',
                required:true,
                value: '1',
                label: 'Совмещать два вида занятости, удовлетворяя разные интересы и потребности (мультизанятость).'
              },
              {
                id: 'question16-b',
                controlName: 'question16',
                required:true,
                value: '2',
                label: 'Выбрать что-то одно, чтобы не распыляться.'
              },
              {
                id: 'question16-c',
                controlName: 'question16',
                required:true,
                value: '3',
                label: 'Отказаться от идеальной работы и согласиться только на высокооплачиваемую.'
              },
              {
                id: 'question16-d',
                controlName: 'question16',
                required:true,
                value: '4',
                label: 'Ждать, пока появится работа, которая устроит по всем параметрам.'
              }
            ]
          },
          {
            title: 'С чего рекомендуется начать работу по созданию личного «антистрессового» арсенала?',
            correct: '2',
            options: [
              {
                id: 'question17-a',
                controlName: 'question17',
                required:true,
                value: '1',
                label: 'Сразу выучить сложные дыхательные техники.'
              },
              {
                id: 'question17-b',
                controlName: 'question17',
                required:true,
                value: '2',
                label: 'Составить максимальный список того, что доставляет удовольствие и радость, и постоянно его дополнять.'
              },
              {
                id: 'question17-c',
                controlName: 'question17',
                required:true,
                value: '3',
                label: 'Купить абонемент в спортзал.'
              },
              {
                id: 'question17-d',
                controlName: 'question17',
                required:true,
                value: '4',
                label: 'Записаться на приём к психологу.'
              }
            ]
          },
        ]
      },
    ]
  },
  {
    courseId:2,
    modules:[
      {
        moduleType:'intermediate',
        moduleNumber:'1',
        moduleTitle:'Боевой стресс и посттравматическое стрессовое расстройство',
        questions:[
          {
            title: 'Какие изменения в эмоциональной сфере могут происходить после получения боевого опыта?',
            correct: '3',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: '1',
                label: 'Только повышение настроения и постоянная эйфория.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: '2',
                label: 'Полное исчезновение любых эмоций.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: '3',
                label: 'Колебания настроения, снижение способности испытывать радость, приступы подавленности, чувство вины.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: '4',
                label: 'Исключительно агрессия и злость на всех окружающих.'
              }
            ]
          },
          {
            title: 'После боевого опыта мир может казаться враждебным, а сам человек – никчёмным. Что важно понять, чтобы начать возвращаться к нормальной жизни?',
            correct: '2',
            options: [
              {
                id: 'question2-a',
                controlName: 'question2',
                required:true,
                value: '1',
                label: 'Нужно смириться, что мир действительно не так хорош, и жить в этом убеждении.'
              },
              {
                id: 'question2-b',
                controlName: 'question2',
                required:true,
                value: '2',
                label: 'Нужно понять, что произошло разрушение прежних представлений о мире и о себе и эти представления можно восстановить с течением времени и с помощью психолога.'
              },
              {
                id: 'question2-c',
                controlName: 'question2',
                required:true,
                value: '3',
                label: 'Нужно убедить себя, что ничего не изменилось, и жить как раньше.'
              },
              {
                id: 'question2-d',
                controlName: 'question2',
                required:true,
                value: '4',
                label: 'Нужно доказать себе и миру, что ты сильный, снова пойдя на риск.'
              }
            ]
          },
          {
            title: 'После пережитого иногда возникает желание полностью убрать из жизни всё, что может напомнить о прошлом, будь то форма, поездки на машине или даже определённые мысли и разговоры. К чему приводит такое избегание?',
            correct: '2',
            options: [
              {
                id: 'question3-a',
                controlName: 'question3',
                required:true,
                value: '1',
                label: 'К быстрому и гарантированному выздоровлению.'
              },
              {
                id: 'question3-b',
                controlName: 'question3',
                required:true,
                value: '2',
                label: 'К тому, что человек остаётся один на один со своей проблемой, отгораживаясь от помощи и возможности её обсудить.'
              },
              {
                id: 'question3-c',
                controlName: 'question3',
                required:true,
                value: '3',
                label: 'К тому, что воспоминания полностью стираются из памяти навсегда.'
              },
              {
                id: 'question3-d',
                controlName: 'question3',
                required:true,
                value: '4',
                label: 'К развитию сверхспособностей и обострению всех чувств.'
              }
            ]
          },
        ]
      },
      {
        moduleType:'intermediate',
        moduleTitle:'Способы преодоления жизненных кризисов',
        moduleNumber:'2',
        questions:[
          {
            title: 'Что чаще всего мешает вернуться к мирной жизни и вызывает главный внутренний конфликт?',
            correct: '4',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: '1',
                label: 'Физическая усталость и нехватка сил для домашних дел.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: '2',
                label: 'Нежелание семьи и общества предоставить ветерану полную свободу действий.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: '3',
                label: 'Отсутствие денег и материальных благ, к которым человек привык на фронте.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: '4',
                label: 'Кризис идентичности, когда человек не может соединить воедино себя «до», «во время» и «после» участия в боевых действиях.'
              }
            ]
          },
          {
            title: 'Кризис – это не всегда только плохо. Какой ещё взгляд на кризис предлагается?',
            correct: '3',
            options: [
              {
                id: 'question2-a',
                controlName: 'question2',
                required:true,
                value: '1',
                label: 'Кризис – это всегда наказание за прошлые ошибки.'
              },
              {
                id: 'question2-b',
                controlName: 'question2',
                required:true,
                value: '2',
                label: 'Кризис – это просто временное помешательство, которое нужно перетерпеть.'
              },
              {
                id: 'question2-c',
                controlName: 'question2',
                required:true,
                value: '3',
                label: 'Кризис – это событие, которое может открывать новые горизонты и возможности, если подойти к нему как к шансу.'
              },
              {
                id: 'question2-d',
                controlName: 'question2',
                required:true,
                value: '4',
                label: 'Кризис – это состояние, в котором лучше всего ничего не менять и плыть по течению.'
              }
            ]
          },
          {
            title: 'Критическая стадия кризиса характеризуется очень тяжёлым состоянием. Что является главным признаком того, что человек оказался именно на этой стадии?',
            correct: '2',
            options: [
              {
                id: 'question3-a',
                controlName: 'question3',
                required:true,
                value: '1',
                label: 'Беспокойство и желание обратиться за советом к друзьям.'
              },
              {
                id: 'question3-b',
                controlName: 'question3',
                required:true,
                value: '2',
                label: 'Чувство беспомощности и безнадёжности, полная дезорганизация поведения, разрушение адаптационных механизмов и непонимание, куда обращаться за помощью.'
              },
              {
                id: 'question3-c',
                controlName: 'question3',
                required:true,
                value: '3',
                label: 'Активный поиск новых решений и мобилизация всех внутренних ресурсов.'
              },
              {
                id: 'question3-d',
                controlName: 'question3',
                required:true,
                value: '4',
                label: 'Использование старых, привычных способов решения, которые уже однажды помогали.'
              }
            ]
          },
          {
            title: 'Какое из перечисленных состояний является ключевым признаком внутреннего ощущения одиночества?',
            correct: '1',
            options: [
              {
                id: 'question4-a',
                controlName: 'question4',
                required:true,
                value: '1',
                label: 'Чувство потерянности в мире, ощущение себя ненужным и отсутствие точки опоры в виде доверительных отношений.'
              },
              {
                id: 'question4-b',
                controlName: 'question4',
                required:true,
                value: '2',
                label: 'Наличие большого количества знакомых и приятелей.'
              },
              {
                id: 'question4-c',
                controlName: 'question4',
                required:true,
                value: '3',
                label: 'Желание побыть одному, чтобы подумать о чём-то важном.'
              },
              {
                id: 'question4-d',
                controlName: 'question4',
                required:true,
                value: '4',
                label: 'Отсутствие свободного времени из-за постоянного общения с людьми.'
              }
            ]
          },
        ]
      },
      {
        moduleType:'intermediate',
        moduleNumber:'3',
        moduleTitle:'Семейные отношения как ресурс для преодоления психологических трудностей',
        questions:[
          {
            title: 'Человеку, пережившему боевой стресс и нуждающемуся в помощи, важно вести себя активно. Что это означает?',
            correct: '3',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: '1',
                label: 'Нужно начать заниматься спортом и вести активный образ жизни.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: '2',
                label: 'Активность означает, что нужно постоянно давать советы другим, а не просить помощи для себя.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: '3',
                label: 'Важно не только говорить о своих потребностях, но и самому предпринимать шаги для их удовлетворения и получения поддержки.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: '4',
                label: 'Нужно как можно реже появляться дома, чтобы не нагружать семью своими проблемами.'
              }
            ]
          },
          {
            title: 'Почему после возвращения с фронта привычная гражданская жизнь может казаться чуждой и вызывать трудности адаптации?',
            correct: '2',
            options: [
              {
                id: 'question2-a',
                controlName: 'question2',
                required:true,
                value: '1',
                label: 'Потому что за время отсутствия все знакомые люди специально изменили своё отношение.'
              },
              {
                id: 'question2-b',
                controlName: 'question2',
                required:true,
                value: '2',
                label: 'Потому что внешне всё выглядит по-старому, но сам человек изменился и ему заново нужно искать смыслы и адаптироваться к «старым – новым» условиям.'
              },
              {
                id: 'question2-c',
                controlName: 'question2',
                required:true,
                value: '3',
                label: 'Потому что в гражданской жизни вообще нет никаких правил и порядка.'
              },
              {
                id: 'question2-d',
                controlName: 'question2',
                required:true,
                value: '4',
                label: 'Потому что семья перестала заботиться о вернувшемся военнослужащем.'
              }
            ]
          },
          {
            title: 'Ветеран говорит: «Жена и дети ждали меня, но я чувствую, что мы стали чужими. Они живут своей жизнью, а я – своей. Я не знаю, как снова стать для них близким». Какие действия будут наиболее эффективными для восстановления близости?',
            correct: '1',
            options: [
              {
                id: 'question3-a',
                controlName: 'question3',
                required:true,
                value: '1',
                label: 'Начать с малого: каждый день находить время для простого разговора с женой, интересоваться делами детей и делиться своими мыслями, даже если это кажется неловким.'
              },
              {
                id: 'question3-b',
                controlName: 'question3',
                required:true,
                value: '2',
                label: 'Дать семье время привыкнуть и не навязываться, подождать, пока они сами проявят инициативу.'
              },
              {
                id: 'question3-c',
                controlName: 'question3',
                required:true,
                value: '3',
                label: 'Собрать семейный совет и объяснить, что теперь всё в семье должно быть по-другому.'
              },
              {
                id: 'question3-d',
                controlName: 'question3',
                required:true,
                value: '4',
                label: 'Сосредоточиться на работе и обеспечении семьи, полагая, что финансовый вклад автоматически восстановит отношения.'
              }
            ]
          },
        ]
      },
      {
        moduleType:'intermediate',
        moduleNumber:'4',
        moduleTitle:'Эффективные методы развития мотивации к самореализации',
        questions:[
          {
            title: 'Ветеран вернулся домой и понимает: нужно пройти медобследование, достроить баню, навестить старых друзей, разобрать накопившиеся счета. С чего ему начать планирование своих дел?',
            correct: '4',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: '1',
                label: 'Начать с самого простого и быстрого дела, чтобы почувствовать удовлетворение от выполненного.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: '2',
                label: 'Составить список из 10 дел на ближайшие 10 лет и строго ему следовать, не отвлекаясь на мелочи.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: '3',
                label: 'Сделать всё и сразу, потому что после боевых действий для него нет невыполнимых задач.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: '4',
                label: 'Разделить все дела на неважные и срочные, выполнить сначала то, что не терпит отлагательств (например, здоровье), а остальное распределить по времени или делегировать.'
              }
            ]
          },
          {
            title: 'Какой инструмент можно использовать для анализа мотивации и принятия решения о необходимости что-то менять в жизни?',
            correct: '4',
            options: [
              {
                id: 'question2-a',
                controlName: 'question2',
                required:true,
                value: '1',
                label: 'Матрица Эйзенхауэра.'
              },
              {
                id: 'question2-b',
                controlName: 'question2',
                required:true,
                value: '2',
                label: 'Правило 10/10/10.'
              },
              {
                id: 'question2-c',
                controlName: 'question2',
                required:true,
                value: '3',
                label: 'Пирамида потребностей.'
              },
              {
                id: 'question2-d',
                controlName: 'question2',
                required:true,
                value: '4',
                label: 'Квадрат Декарта, чтобы взвесить плюсы и минусы сохранения текущего положения дел и изменений.'
              }
            ]
          },
          {
            title: 'Почему обращение за психологической или медицинской помощью может быть необходимо тем, кто вернулся с фронта?',
            correct: '3',
            options: [
              {
                id: 'question3-a',
                controlName: 'question3',
                required:true,
                value: '1',
                label: 'Потому что все ветераны автоматически имеют психические недуги.'
              },
              {
                id: 'question3-b',
                controlName: 'question3',
                required:true,
                value: '2',
                label: 'Потому что врачам нужно отчитываться о количестве пациентов.'
              },
              {
                id: 'question3-c',
                controlName: 'question3',
                required:true,
                value: '3',
                label: 'Потому что пережитый тяжёлый стресс может вызывать проблемы со сном, тревогу, признаки депрессии или ПТСР, которые мешают нормальной жизни, а специалист поможет с ними справиться.'
              },
              {
                id: 'question3-d',
                controlName: 'question3',
                required:true,
                value: '4',
                label: 'Потому что так принято в обществе'
              }
            ]
          },
        ]
      },
      {
        moduleType:'intermediate',
        moduleNumber:'5',
        moduleTitle:'Мотивация и траектория: построение новой карьеры ветерана СВО',
        questions:[
          {
            title: 'Ветеран говорит: «Раньше я жил как будто на черновик, а теперь хочу по-настоящему. Но не знаю, с чего начать. Всё, что делал раньше на гражданке, кажется теперь пустым». Как начать проектирование новой жизни?',
            correct: '2',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: '1',
                label: 'Возврат на прежнюю высокооплачиваемую работу ради стабильности.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: '2',
                label: 'Погружение в детские воспоминания и поиск занятий, приносящих радость.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: '3',
                label: 'Запись на курсы по самой востребованной профессии в городе.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: '4',
                label: 'Полугодовой отпуск и пассивное ожидание новых желаний.'
              }
            ]
          },
          {
            title: 'Как ограничение по здоровью (например, потеря слуха) может стать суперсилой и преимуществом при выборе профессии?',
            correct: '1',
            options: [
              {
                id: 'question2-a',
                controlName: 'question2',
                required:true,
                value: '1',
                label: 'Потеря слуха становится суперсилой для работы в условиях, где шум является проблемой для других (шумный цех, работа в такси), позволяя лучше фокусироваться.'
              },
              {
                id: 'question2-b',
                controlName: 'question2',
                required:true,
                value: '2',
                label: 'Это ограничение не может стать преимуществом – это всегда только минус.'
              },
              {
                id: 'question2-c',
                controlName: 'question2',
                required:true,
                value: '3',
                label: 'С таким ограничением можно работать только на дому и никуда не выходить.'
              },
              {
                id: 'question2-d',
                controlName: 'question2',
                required:true,
                value: '4',
                label: 'Это повод оформить инвалидность и больше не работать.'
              }
            ]
          },
          {
            title: 'Как поступить, если работа мечты низкооплачиваемая, а высокооплачиваемая кажется скучной?',
            correct: '1',
            options: [
              {
                id: 'question3-a',
                controlName: 'question3',
                required:true,
                value: '1',
                label: 'Совмещать два вида занятости, удовлетворяя разные интересы и потребности (мультизанятость).'
              },
              {
                id: 'question3-b',
                controlName: 'question3',
                required:true,
                value: '2',
                label: 'Выбрать что-то одно, чтобы не распыляться.'
              },
              {
                id: 'question3-c',
                controlName: 'question3',
                required:true,
                value: '3',
                label: 'Отказаться от идеальной работы и согласиться только на высокооплачиваемую.'
              },
              {
                id: 'question3-d',
                controlName: 'question3',
                required:true,
                value: '4',
                label: 'Ждать, пока появится работа, которая устроит по всем параметрам.'
              }
            ]
          },
        ]
      },
      {
        moduleType:'intermediate',
        moduleNumber:'6',
        moduleTitle:'Упражнения совладания со стрессом',
        questions:[
          {
            title: 'С чего рекомендуется начать работу по созданию личного «антистрессового» арсенала?',
            correct: '2',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: '1',
                label: 'Сразу выучить сложные дыхательные техники.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: '2',
                label: 'Составить максимальный список того, что доставляет удовольствие и радость, и постоянно его дополнять.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: '3',
                label: 'Купить абонемент в спортзал.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: '4',
                label: 'Записаться на приём к психологу.'
              }
            ]
          },
        ]
      },
      {
        moduleType:'intermediate',
        moduleNumber:'7',
        moduleTitle:'Анонс программы наставничества «Равный - равному» ',
        questions:[
          {
            title: 'Для кого предназначена программа наставничества?',
            correct: '3',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: '1',
                label: 'Для всех ветеранов СВО без исключения, главное - желание.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: '2',
                label: 'Для ветеранов с высшим психологическим образованием.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: '3',
                label: 'Для ветеранов, которые преодолели свои кризисы и готовы помогать другим бойцам на пути возвращения к мирной жизни.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: '4',
                label: 'Для родственников ветеранов, которые хотят помочь своим близким.'
              }
            ]
          },
        ]
      },
      {
        moduleType:'final',
        moduleNumber:'1',
        correctAnswersCount:13,
        questions:[
          {
            title: 'Какие изменения в эмоциональной сфере могут происходить после получения боевого опыта?',
            correct: '3',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: '1',
                label: 'Только повышение настроения и постоянная эйфория.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: '2',
                label: 'Полное исчезновение любых эмоций.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: '3',
                label: 'Колебания настроения, снижение способности испытывать радость, приступы подавленности, чувство вины.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: '4',
                label: 'Исключительно агрессия и злость на всех окружающих.'
              }
            ]
          },
          {
            title: 'После боевого опыта мир может казаться враждебным, а сам человек – никчёмным. Что важно понять, чтобы начать возвращаться к нормальной жизни?',
            correct: '2',
            options: [
              {
                id: 'question2-a',
                controlName: 'question2',
                required:true,
                value: '1',
                label: 'Нужно смириться, что мир действительно не так хорош, и жить в этом убеждении.'
              },
              {
                id: 'question2-b',
                controlName: 'question2',
                required:true,
                value: '2',
                label: 'Нужно понять, что произошло разрушение прежних представлений о мире и о себе и эти представления можно восстановить с течением времени и с помощью психолога.'
              },
              {
                id: 'question2-c',
                controlName: 'question2',
                required:true,
                value: '3',
                label: 'Нужно убедить себя, что ничего не изменилось, и жить как раньше.'
              },
              {
                id: 'question2-d',
                controlName: 'question2',
                required:true,
                value: '4',
                label: 'Нужно доказать себе и миру, что ты сильный, снова пойдя на риск.'
              }
            ]
          },
          {
            title: 'После пережитого иногда возникает желание полностью убрать из жизни всё, что может напомнить о прошлом, будь то форма, поездки на машине или даже определённые мысли и разговоры. К чему приводит такое избегание?',
            correct: '2',
            options: [
              {
                id: 'question3-a',
                controlName: 'question3',
                required:true,
                value: '1',
                label: 'К быстрому и гарантированному выздоровлению.'
              },
              {
                id: 'question3-b',
                controlName: 'question3',
                required:true,
                value: '2',
                label: 'К тому, что человек остаётся один на один со своей проблемой, отгораживаясь от помощи и возможности её обсудить.'
              },
              {
                id: 'question3-c',
                controlName: 'question3',
                required:true,
                value: '3',
                label: 'К тому, что воспоминания полностью стираются из памяти навсегда.'
              },
              {
                id: 'question3-d',
                controlName: 'question3',
                required:true,
                value: '4',
                label: 'К развитию сверхспособностей и обострению всех чувств.'
              }
            ]
          },
          {
            title: 'Что чаще всего мешает вернуться к мирной жизни и вызывает главный внутренний конфликт?',
            correct: '4',
            options: [
              {
                id: 'question4-a',
                controlName: 'question4',
                required:true,
                value: '1',
                label: 'Физическая усталость и нехватка сил для домашних дел.'
              },
              {
                id: 'question4-b',
                controlName: 'question4',
                required:true,
                value: '2',
                label: 'Нежелание семьи и общества предоставить ветерану полную свободу действий.'
              },
              {
                id: 'question4-c',
                controlName: 'question4',
                required:true,
                value: '3',
                label: 'Отсутствие денег и материальных благ, к которым человек привык на фронте.'
              },
              {
                id: 'question4-d',
                controlName: 'question4',
                required:true,
                value: '4',
                label: 'Кризис идентичности, когда человек не может соединить воедино себя «до», «во время» и «после» участия в боевых действиях.'
              }
            ]
          },
          {
            title: 'Кризис – это не всегда только плохо. Какой ещё взгляд на кризис предлагается?',
            correct: '3',
            options: [
              {
                id: 'question5-a',
                controlName: 'question5',
                required:true,
                value: '1',
                label: 'Кризис – это всегда наказание за прошлые ошибки.'
              },
              {
                id: 'question5-b',
                controlName: 'question5',
                required:true,
                value: '2',
                label: 'Кризис – это просто временное помешательство, которое нужно перетерпеть.'
              },
              {
                id: 'question5-c',
                controlName: 'question5',
                required:true,
                value: '3',
                label: 'Кризис – это событие, которое может открывать новые горизонты и возможности, если подойти к нему как к шансу.'
              },
              {
                id: 'question5-d',
                controlName: 'question5',
                required:true,
                value: '4',
                label: 'Кризис – это состояние, в котором лучше всего ничего не менять и плыть по течению.'
              }
            ]
          },
          {
            title: 'Критическая стадия кризиса характеризуется очень тяжёлым состоянием. Что является главным признаком того, что человек оказался именно на этой стадии?',
            correct: '2',
            options: [
              {
                id: 'question6-a',
                controlName: 'question6',
                required:true,
                value: '1',
                label: 'Беспокойство и желание обратиться за советом к друзьям.'
              },
              {
                id: 'question6-b',
                controlName: 'question6',
                required:true,
                value: '2',
                label: 'Чувство беспомощности и безнадёжности, полная дезорганизация поведения, разрушение адаптационных механизмов и непонимание, куда обращаться за помощью.'
              },
              {
                id: 'question6-c',
                controlName: 'question6',
                required:true,
                value: '3',
                label: 'Активный поиск новых решений и мобилизация всех внутренних ресурсов.'
              },
              {
                id: 'question6-d',
                controlName: 'question6',
                required:true,
                value: '4',
                label: 'Использование старых, привычных способов решения, которые уже однажды помогали.'
              }
            ]
          },
          {
            title: 'Какое из перечисленных состояний является ключевым признаком внутреннего ощущения одиночества?',
            correct: '1',
            options: [
              {
                id: 'question7-a',
                controlName: 'question7',
                required:true,
                value: '1',
                label: 'Чувство потерянности в мире, ощущение себя ненужным и отсутствие точки опоры в виде доверительных отношений.'
              },
              {
                id: 'question7-b',
                controlName: 'question7',
                required:true,
                value: '2',
                label: 'Наличие большого количества знакомых и приятелей.'
              },
              {
                id: 'question7-c',
                controlName: 'question7',
                required:true,
                value: '3',
                label: 'Желание побыть одному, чтобы подумать о чём-то важном.'
              },
              {
                id: 'question7-d',
                controlName: 'question7',
                required:true,
                value: '4',
                label: 'Отсутствие свободного времени из-за постоянного общения с людьми.'
              }
            ]
          },
          {
            title: 'Человеку, пережившему боевой стресс и нуждающемуся в помощи, важно вести себя активно. Что это означает?',
            correct: '3',
            options: [
              {
                id: 'question8-a',
                controlName: 'question8',
                required:true,
                value: '1',
                label: 'Нужно начать заниматься спортом и вести активный образ жизни.'
              },
              {
                id: 'question8-b',
                controlName: 'question8',
                required:true,
                value: '2',
                label: 'Активность означает, что нужно постоянно давать советы другим, а не просить помощи для себя.'
              },
              {
                id: 'question8-c',
                controlName: 'question8',
                required:true,
                value: '3',
                label: 'Важно не только говорить о своих потребностях, но и самому предпринимать шаги для их удовлетворения и получения поддержки.'
              },
              {
                id: 'question8-d',
                controlName: 'question8',
                required:true,
                value: '4',
                label: 'Нужно как можно реже появляться дома, чтобы не нагружать семью своими проблемами.'
              }
            ]
          },
          {
            title: 'Почему после возвращения с фронта привычная гражданская жизнь может казаться чуждой и вызывать трудности адаптации?',
            correct: '2',
            options: [
              {
                id: 'question9-a',
                controlName: 'question9',
                required:true,
                value: '1',
                label: 'Потому что за время отсутствия все знакомые люди специально изменили своё отношение.'
              },
              {
                id: 'question9-b',
                controlName: 'question9',
                required:true,
                value: '2',
                label: 'Потому что внешне всё выглядит по-старому, но сам человек изменился и ему заново нужно искать смыслы и адаптироваться к «старым – новым» условиям.'
              },
              {
                id: 'question9-c',
                controlName: 'question9',
                required:true,
                value: '3',
                label: 'Потому что в гражданской жизни вообще нет никаких правил и порядка.'
              },
              {
                id: 'question9-d',
                controlName: 'question9',
                required:true,
                value: '4',
                label: 'Потому что семья перестала заботиться о вернувшемся военнослужащем.'
              }
            ]
          },
          {
            title: 'Ветеран говорит: «Жена и дети ждали меня, но я чувствую, что мы стали чужими. Они живут своей жизнью, а я – своей. Я не знаю, как снова стать для них близким». Какие действия будут наиболее эффективными для восстановления близости?',
            correct: '1',
            options: [
              {
                id: 'question10-a',
                controlName: 'question10',
                required:true,
                value: '1',
                label: 'Начать с малого: каждый день находить время для простого разговора с женой, интересоваться делами детей и делиться своими мыслями, даже если это кажется неловким.'
              },
              {
                id: 'question10-b',
                controlName: 'question10',
                required:true,
                value: '2',
                label: 'Дать семье время привыкнуть и не навязываться, подождать, пока они сами проявят инициативу.'
              },
              {
                id: 'question10-c',
                controlName: 'question10',
                required:true,
                value: '3',
                label: 'Собрать семейный совет и объяснить, что теперь всё в семье должно быть по-другому.'
              },
              {
                id: 'question10-d',
                controlName: 'question10',
                required:true,
                value: '4',
                label: 'Сосредоточиться на работе и обеспечении семьи, полагая, что финансовый вклад автоматически восстановит отношения.'
              }
            ]
          },
          {
            title: 'Ветеран вернулся домой и понимает: нужно пройти медобследование, достроить баню, навестить старых друзей, разобрать накопившиеся счета. С чего ему начать планирование своих дел?',
            correct: '4',
            options: [
              {
                id: 'question11-a',
                controlName: 'question11',
                required:true,
                value: '1',
                label: 'Начать с самого простого и быстрого дела, чтобы почувствовать удовлетворение от выполненного.'
              },
              {
                id: 'question11-b',
                controlName: 'question11',
                required:true,
                value: '2',
                label: 'Составить список из 10 дел на ближайшие 10 лет и строго ему следовать, не отвлекаясь на мелочи.'
              },
              {
                id: 'question11-c',
                controlName: 'question11',
                required:true,
                value: '3',
                label: 'Сделать всё и сразу, потому что после боевых действий для него нет невыполнимых задач.'
              },
              {
                id: 'question11-d',
                controlName: 'question11',
                required:true,
                value: '4',
                label: 'Разделить все дела на неважные и срочные, выполнить сначала то, что не терпит отлагательств (например, здоровье), а остальное распределить по времени или делегировать.'
              }
            ]
          },
          {
            title: 'Какой инструмент можно использовать для анализа мотивации и принятия решения о необходимости что-то менять в жизни?',
            correct: '4',
            options: [
              {
                id: 'question12-a',
                controlName: 'question12',
                required:true,
                value: '1',
                label: 'Матрица Эйзенхауэра.'
              },
              {
                id: 'question12-b',
                controlName: 'question12',
                required:true,
                value: '2',
                label: 'Правило 10/10/10.'
              },
              {
                id: 'question12-c',
                controlName: 'question12',
                required:true,
                value: '3',
                label: 'Пирамида потребностей.'
              },
              {
                id: 'question12-d',
                controlName: 'question12',
                required:true,
                value: '4',
                label: 'Квадрат Декарта, чтобы взвесить плюсы и минусы сохранения текущего положения дел и изменений.'
              }
            ]
          },
          {
            title: 'Почему обращение за психологической или медицинской помощью может быть необходимо тем, кто вернулся с фронта?',
            correct: '3',
            options: [
              {
                id: 'question13-a',
                controlName: 'question13',
                required:true,
                value: '1',
                label: 'Потому что все ветераны автоматически имеют психические недуги.'
              },
              {
                id: 'question13-b',
                controlName: 'question13',
                required:true,
                value: '2',
                label: 'Потому что врачам нужно отчитываться о количестве пациентов.'
              },
              {
                id: 'question13-c',
                controlName: 'question13',
                required:true,
                value: '3',
                label: 'Потому что пережитый тяжёлый стресс может вызывать проблемы со сном, тревогу, признаки депрессии или ПТСР, которые мешают нормальной жизни, а специалист поможет с ними справиться.'
              },
              {
                id: 'question13-d',
                controlName: 'question13',
                required:true,
                value: '4',
                label: 'Потому что так принято в обществе'
              }
            ]
          },
          {
            title: 'Ветеран говорит: «Раньше я жил как будто на черновик, а теперь хочу по-настоящему. Но не знаю, с чего начать. Всё, что делал раньше на гражданке, кажется теперь пустым». Как начать проектирование новой жизни?',
            correct: '2',
            options: [
              {
                id: 'question14-a',
                controlName: 'question14',
                required:true,
                value: '1',
                label: 'Возврат на прежнюю высокооплачиваемую работу ради стабильности.'
              },
              {
                id: 'question14-b',
                controlName: 'question14',
                required:true,
                value: '2',
                label: 'Погружение в детские воспоминания и поиск занятий, приносящих радость.'
              },
              {
                id: 'question14-c',
                controlName: 'question14',
                required:true,
                value: '3',
                label: 'Запись на курсы по самой востребованной профессии в городе.'
              },
              {
                id: 'question14-d',
                controlName: 'question14',
                required:true,
                value: '4',
                label: 'Полугодовой отпуск и пассивное ожидание новых желаний.'
              }
            ]
          },
          {
            title: 'Как ограничение по здоровью (например, потеря слуха) может стать суперсилой и преимуществом при выборе профессии?',
            correct: '1',
            options: [
              {
                id: 'question15-a',
                controlName: 'question15',
                required:true,
                value: '1',
                label: 'Потеря слуха становится суперсилой для работы в условиях, где шум является проблемой для других (шумный цех, работа в такси), позволяя лучше фокусироваться.'
              },
              {
                id: 'question15-b',
                controlName: 'question15',
                required:true,
                value: '2',
                label: 'Это ограничение не может стать преимуществом – это всегда только минус.'
              },
              {
                id: 'question15-c',
                controlName: 'question15',
                required:true,
                value: '3',
                label: 'С таким ограничением можно работать только на дому и никуда не выходить.'
              },
              {
                id: 'question15-d',
                controlName: 'question15',
                required:true,
                value: '4',
                label: 'Это повод оформить инвалидность и больше не работать.'
              }
            ]
          },
          {
            title: 'Как поступить, если работа мечты низкооплачиваемая, а высокооплачиваемая кажется скучной?',
            correct: '1',
            options: [
              {
                id: 'question16-a',
                controlName: 'question16',
                required:true,
                value: '1',
                label: 'Совмещать два вида занятости, удовлетворяя разные интересы и потребности (мультизанятость).'
              },
              {
                id: 'question16-b',
                controlName: 'question16',
                required:true,
                value: '2',
                label: 'Выбрать что-то одно, чтобы не распыляться.'
              },
              {
                id: 'question16-c',
                controlName: 'question16',
                required:true,
                value: '3',
                label: 'Отказаться от идеальной работы и согласиться только на высокооплачиваемую.'
              },
              {
                id: 'question16-d',
                controlName: 'question16',
                required:true,
                value: '4',
                label: 'Ждать, пока появится работа, которая устроит по всем параметрам.'
              }
            ]
          },
          {
            title: 'С чего рекомендуется начать работу по созданию личного «антистрессового» арсенала?',
            correct: '2',
            options: [
              {
                id: 'question17-a',
                controlName: 'question17',
                required:true,
                value: '1',
                label: 'Сразу выучить сложные дыхательные техники.'
              },
              {
                id: 'question17-b',
                controlName: 'question17',
                required:true,
                value: '2',
                label: 'Составить максимальный список того, что доставляет удовольствие и радость, и постоянно его дополнять.'
              },
              {
                id: 'question17-c',
                controlName: 'question17',
                required:true,
                value: '3',
                label: 'Купить абонемент в спортзал.'
              },
              {
                id: 'question17-d',
                controlName: 'question17',
                required:true,
                value: '4',
                label: 'Записаться на приём к психологу.'
              }
            ]
          },
        ]
      },
    ]
  },
  {
    courseId:3,
    modules:[
      {
        moduleType:'intermediate',
        moduleNumber:'1',
        questions:[
          {
            title: 'Промежуточный тест 1. Что такое JavaScript и для чего он используется?',
            correct: 'a',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: 'a',
                label: 'JavaScript — это высокоуровневый язык программирования, который используется для добавления интерактивности на веб-страницы, обработки событий, работы с DOM и создания веб-приложений.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: 'b',
                label: 'JavaScript — это система управления базами данных, предназначенная для хранения и обработки больших объёмов информации на сервере.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: 'c',
                label: 'JavaScript — это операционная система, которая позволяет запускать программы и управлять оборудованием на компьютере.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: 'd',
                label: 'JavaScript — это браузер, используемый для отображения HTML и CSS страниц в интернете.'
              }
            ]
          },
          {
            title: 'Как правильно объявлять переменные в JavaScript и чем отличаются их виды?',
            correct: 'd',
            options: [
              {
                id: 'question2-a',
                controlName: 'question2',
                required:true,
                value: 'a',
                label: 'Переменная объявляется через let, что позволяет создавать блоковую область видимости, предотвращает повторное объявление и является предпочтительным способом в современном JS.'
              },
              {
                id: 'question2-b',
                controlName: 'question2',
                required:true,
                value: 'b',
                label: 'Переменная объявляется через var, которая имеет функциональную область видимости и может быть переопределена или повторно объявлена в одной функции.'
              },
              {
                id: 'question2-c',
                controlName: 'question2',
                required:true,
                value: 'c',
                label: 'Переменная объявляется через const, что позволяет создать неизменяемую ссылку на значение, а также предотвращает повторное присвоение.'
              },
              {
                id: 'question2-d',
                controlName: 'question2',
                required:true,
                value: 'd',
                label: 'Все варианты верны: let, var и const имеют свои особенности, и правильный выбор зависит от конкретной ситуации и области видимости.'
              }
            ]
          },
          {
            title: 'Что такое массив (Array) в JavaScript и как он используется?',
            correct: 'a',
            options: [
              {
                id: 'question3-a',
                controlName: 'question3',
                required:true,
                value: 'a',
                label: 'Array — это структура данных, предназначенная для хранения упорядоченных списков значений, которые могут быть любого типа, включая числа, строки, объекты и даже другие массивы.'
              },
              {
                id: 'question3-b',
                controlName: 'question3',
                required:true,
                value: 'b',
                label: 'Array хранит только строки, и предназначен исключительно для работы с текстовой информацией.'
              },
              {
                id: 'question3-c',
                controlName: 'question3',
                required:true,
                value: 'c',
                label: 'Array может хранить только числа и используется только для математических операций или статистических расчётов.'
              },
              {
                id: 'question3-d',
                controlName: 'question3',
                required:true,
                value: 'd',
                label: 'Array — это функция, которая выполняет операции над данными и возвращает результат вычислений.'
              }
            ]
          },
          {
            title: 'Как работает оператор === в JavaScript и в чём его отличие от ==?',
            correct: 'a',
            options: [
              {
                id: 'question4-a',
                controlName: 'question4',
                required:true,
                value: 'a',
                label: 'Оператор === сравнивает два значения без приведения типов, что означает, что типы и значения должны совпадать, чтобы результат был true.'
              },
              {
                id: 'question4-b',
                controlName: 'question4',
                required:true,
                value: 'b',
                label: 'Оператор === приводит типы автоматически перед сравнением, что может приводить к неожиданным результатам при работе с разными типами данных.'
              },
              {
                id: 'question4-c',
                controlName: 'question4',
                required:true,
                value: 'c',
                label: 'Оператор === работает только со строками и не применим к числам, объектам или другим типам данных.'
              },
              {
                id: 'question4-d',
                controlName: 'question4',
                required:true,
                value: 'd',
                label: 'Оператор === и == работают одинаково и различий между ними нет, поэтому их можно использовать взаимозаменяемо.'
              }
            ]
          }
        ]
      },
      {
        moduleType:'intermediate',
        moduleNumber:'2',
        questions:[
          {
            title: 'Промежуточный тест 2. Что такое JavaScript и для чего он используется?',
            correct: 'a',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: 'a',
                label: 'JavaScript — это высокоуровневый язык программирования, который используется для добавления интерактивности на веб-страницы, обработки событий, работы с DOM и создания веб-приложений.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: 'b',
                label: 'JavaScript — это система управления базами данных, предназначенная для хранения и обработки больших объёмов информации на сервере.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: 'c',
                label: 'JavaScript — это операционная система, которая позволяет запускать программы и управлять оборудованием на компьютере.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: 'd',
                label: 'JavaScript — это браузер, используемый для отображения HTML и CSS страниц в интернете.'
              }
            ]
          },
          {
            title: 'Как правильно объявлять переменные в JavaScript и чем отличаются их виды?',
            correct: 'd',
            options: [
              {
                id: 'question2-a',
                controlName: 'question2',
                required:true,
                value: 'a',
                label: 'Переменная объявляется через let, что позволяет создавать блоковую область видимости, предотвращает повторное объявление и является предпочтительным способом в современном JS.'
              },
              {
                id: 'question2-b',
                controlName: 'question2',
                required:true,
                value: 'b',
                label: 'Переменная объявляется через var, которая имеет функциональную область видимости и может быть переопределена или повторно объявлена в одной функции.'
              },
              {
                id: 'question2-c',
                controlName: 'question2',
                required:true,
                value: 'c',
                label: 'Переменная объявляется через const, что позволяет создать неизменяемую ссылку на значение, а также предотвращает повторное присвоение.'
              },
              {
                id: 'question2-d',
                controlName: 'question2',
                required:true,
                value: 'd',
                label: 'Все варианты верны: let, var и const имеют свои особенности, и правильный выбор зависит от конкретной ситуации и области видимости.'
              }
            ]
          },
          {
            title: 'Что такое массив (Array) в JavaScript и как он используется?',
            correct: 'a',
            options: [
              {
                id: 'question3-a',
                controlName: 'question3',
                required:true,
                value: 'a',
                label: 'Array — это структура данных, предназначенная для хранения упорядоченных списков значений, которые могут быть любого типа, включая числа, строки, объекты и даже другие массивы.'
              },
              {
                id: 'question3-b',
                controlName: 'question3',
                required:true,
                value: 'b',
                label: 'Array хранит только строки, и предназначен исключительно для работы с текстовой информацией.'
              },
              {
                id: 'question3-c',
                controlName: 'question3',
                required:true,
                value: 'c',
                label: 'Array может хранить только числа и используется только для математических операций или статистических расчётов.'
              },
              {
                id: 'question3-d',
                controlName: 'question3',
                required:true,
                value: 'd',
                label: 'Array — это функция, которая выполняет операции над данными и возвращает результат вычислений.'
              }
            ]
          },
          {
            title: 'Как работает оператор === в JavaScript и в чём его отличие от ==?',
            correct: 'a',
            options: [
              {
                id: 'question4-a',
                controlName: 'question4',
                required:true,
                value: 'a',
                label: 'Оператор === сравнивает два значения без приведения типов, что означает, что типы и значения должны совпадать, чтобы результат был true.'
              },
              {
                id: 'question4-b',
                controlName: 'question4',
                required:true,
                value: 'b',
                label: 'Оператор === приводит типы автоматически перед сравнением, что может приводить к неожиданным результатам при работе с разными типами данных.'
              },
              {
                id: 'question4-c',
                controlName: 'question4',
                required:true,
                value: 'c',
                label: 'Оператор === работает только со строками и не применим к числам, объектам или другим типам данных.'
              },
              {
                id: 'question4-d',
                controlName: 'question4',
                required:true,
                value: 'd',
                label: 'Оператор === и == работают одинаково и различий между ними нет, поэтому их можно использовать взаимозаменяемо.'
              }
            ]
          }
        ]
      },
      {
        moduleType:'intermediate',
        moduleNumber:'3',
        questions:[
          {
            title: 'Промежуточный тест 3. Что такое JavaScript и для чего он используется?',
            correct: 'a',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: 'a',
                label: 'JavaScript — это высокоуровневый язык программирования, который используется для добавления интерактивности на веб-страницы, обработки событий, работы с DOM и создания веб-приложений.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: 'b',
                label: 'JavaScript — это система управления базами данных, предназначенная для хранения и обработки больших объёмов информации на сервере.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: 'c',
                label: 'JavaScript — это операционная система, которая позволяет запускать программы и управлять оборудованием на компьютере.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: 'd',
                label: 'JavaScript — это браузер, используемый для отображения HTML и CSS страниц в интернете.'
              }
            ]
          },
          {
            title: 'Как правильно объявлять переменные в JavaScript и чем отличаются их виды?',
            correct: 'd',
            options: [
              {
                id: 'question2-a',
                controlName: 'question2',
                required:true,
                value: 'a',
                label: 'Переменная объявляется через let, что позволяет создавать блоковую область видимости, предотвращает повторное объявление и является предпочтительным способом в современном JS.'
              },
              {
                id: 'question2-b',
                controlName: 'question2',
                required:true,
                value: 'b',
                label: 'Переменная объявляется через var, которая имеет функциональную область видимости и может быть переопределена или повторно объявлена в одной функции.'
              },
              {
                id: 'question2-c',
                controlName: 'question2',
                required:true,
                value: 'c',
                label: 'Переменная объявляется через const, что позволяет создать неизменяемую ссылку на значение, а также предотвращает повторное присвоение.'
              },
              {
                id: 'question2-d',
                controlName: 'question2',
                required:true,
                value: 'd',
                label: 'Все варианты верны: let, var и const имеют свои особенности, и правильный выбор зависит от конкретной ситуации и области видимости.'
              }
            ]
          },
          {
            title: 'Что такое массив (Array) в JavaScript и как он используется?',
            correct: 'a',
            options: [
              {
                id: 'question3-a',
                controlName: 'question3',
                required:true,
                value: 'a',
                label: 'Array — это структура данных, предназначенная для хранения упорядоченных списков значений, которые могут быть любого типа, включая числа, строки, объекты и даже другие массивы.'
              },
              {
                id: 'question3-b',
                controlName: 'question3',
                required:true,
                value: 'b',
                label: 'Array хранит только строки, и предназначен исключительно для работы с текстовой информацией.'
              },
              {
                id: 'question3-c',
                controlName: 'question3',
                required:true,
                value: 'c',
                label: 'Array может хранить только числа и используется только для математических операций или статистических расчётов.'
              },
              {
                id: 'question3-d',
                controlName: 'question3',
                required:true,
                value: 'd',
                label: 'Array — это функция, которая выполняет операции над данными и возвращает результат вычислений.'
              }
            ]
          },
          {
            title: 'Как работает оператор === в JavaScript и в чём его отличие от ==?',
            correct: 'a',
            options: [
              {
                id: 'question4-a',
                controlName: 'question4',
                required:true,
                value: 'a',
                label: 'Оператор === сравнивает два значения без приведения типов, что означает, что типы и значения должны совпадать, чтобы результат был true.'
              },
              {
                id: 'question4-b',
                controlName: 'question4',
                required:true,
                value: 'b',
                label: 'Оператор === приводит типы автоматически перед сравнением, что может приводить к неожиданным результатам при работе с разными типами данных.'
              },
              {
                id: 'question4-c',
                controlName: 'question4',
                required:true,
                value: 'c',
                label: 'Оператор === работает только со строками и не применим к числам, объектам или другим типам данных.'
              },
              {
                id: 'question4-d',
                controlName: 'question4',
                required:true,
                value: 'd',
                label: 'Оператор === и == работают одинаково и различий между ними нет, поэтому их можно использовать взаимозаменяемо.'
              }
            ]
          }
        ]
      },
      {
        moduleType:'final',
        moduleNumber:'1',
        questions:[
          {
            title: 'Финальный тест 1 .Что такое JavaScript и для чего он используется?',
            correct: 'a',
            options: [
              {
                id: 'question1-a',
                controlName: 'question1',
                required:true,
                value: 'a',
                label: 'JavaScript — это высокоуровневый язык программирования, который используется для добавления интерактивности на веб-страницы, обработки событий, работы с DOM и создания веб-приложений.'
              },
              {
                id: 'question1-b',
                controlName: 'question1',
                required:true,
                value: 'b',
                label: 'JavaScript — это система управления базами данных, предназначенная для хранения и обработки больших объёмов информации на сервере.'
              },
              {
                id: 'question1-c',
                controlName: 'question1',
                required:true,
                value: 'c',
                label: 'JavaScript — это операционная система, которая позволяет запускать программы и управлять оборудованием на компьютере.'
              },
              {
                id: 'question1-d',
                controlName: 'question1',
                required:true,
                value: 'd',
                label: 'JavaScript — это браузер, используемый для отображения HTML и CSS страниц в интернете.'
              }
            ]
          },
          {
            title: 'Как правильно объявлять переменные в JavaScript и чем отличаются их виды?',
            correct: 'd',
            options: [
              {
                id: 'question2-a',
                controlName: 'question2',
                required:true,
                value: 'a',
                label: 'Переменная объявляется через let, что позволяет создавать блоковую область видимости, предотвращает повторное объявление и является предпочтительным способом в современном JS.'
              },
              {
                id: 'question2-b',
                controlName: 'question2',
                required:true,
                value: 'b',
                label: 'Переменная объявляется через var, которая имеет функциональную область видимости и может быть переопределена или повторно объявлена в одной функции.'
              },
              {
                id: 'question2-c',
                controlName: 'question2',
                required:true,
                value: 'c',
                label: 'Переменная объявляется через const, что позволяет создать неизменяемую ссылку на значение, а также предотвращает повторное присвоение.'
              },
              {
                id: 'question2-d',
                controlName: 'question2',
                required:true,
                value: 'd',
                label: 'Все варианты верны: let, var и const имеют свои особенности, и правильный выбор зависит от конкретной ситуации и области видимости.'
              }
            ]
          },
          {
            title: 'Что такое массив (Array) в JavaScript и как он используется?',
            correct: 'a',
            options: [
              {
                id: 'question3-a',
                controlName: 'question3',
                required:true,
                value: 'a',
                label: 'Array — это структура данных, предназначенная для хранения упорядоченных списков значений, которые могут быть любого типа, включая числа, строки, объекты и даже другие массивы.'
              },
              {
                id: 'question3-b',
                controlName: 'question3',
                required:true,
                value: 'b',
                label: 'Array хранит только строки, и предназначен исключительно для работы с текстовой информацией.'
              },
              {
                id: 'question3-c',
                controlName: 'question3',
                required:true,
                value: 'c',
                label: 'Array может хранить только числа и используется только для математических операций или статистических расчётов.'
              },
              {
                id: 'question3-d',
                controlName: 'question3',
                required:true,
                value: 'd',
                label: 'Array — это функция, которая выполняет операции над данными и возвращает результат вычислений.'
              }
            ]
          },
          {
            title: 'Как работает оператор === в JavaScript и в чём его отличие от ==?',
            correct: 'a',
            options: [
              {
                id: 'question4-a',
                controlName: 'question4',
                required:true,
                value: 'a',
                label: 'Оператор === сравнивает два значения без приведения типов, что означает, что типы и значения должны совпадать, чтобы результат был true.'
              },
              {
                id: 'question4-b',
                controlName: 'question4',
                required:true,
                value: 'b',
                label: 'Оператор === приводит типы автоматически перед сравнением, что может приводить к неожиданным результатам при работе с разными типами данных.'
              },
              {
                id: 'question4-c',
                controlName: 'question4',
                required:true,
                value: 'c',
                label: 'Оператор === работает только со строками и не применим к числам, объектам или другим типам данных.'
              },
              {
                id: 'question4-d',
                controlName: 'question4',
                required:true,
                value: 'd',
                label: 'Оператор === и == работают одинаково и различий между ними нет, поэтому их можно использовать взаимозаменяемо.'
              }
            ]
          }
        ]
      },
    ]
  }
]
